export default {
  "rainfall": "累计雨量,mm",
  "Evaporation": "蒸发量,g",
  "soilTemp": "土壤温度,℃",
  "soilHumi": "土壤湿度,%",
  "soilCond": "土壤电导率,uS/cm",
  "level": "水位,m",
  "PH": "PH",
  "ORP": "ORP,mv",
  "negativeOxygen": "负氧离子,个/cm³",
  "CO2": "二氧化碳,ppm",
  "lightIntensity": "光照,lux",
  "ambientTemp1": "环境温度1,℃",
  "ambientHum1": "环境湿度1,%",
  "pressure1": "气压1,Kpa",
  "Photosynthesis": "光合,μmol/m²",
  "TotalRadiation": "总辐射,HW/m2",
  "ultravioletRays": "紫外线,W/m²",
  "NetRadiation": "净辐射,HW/m²",
  "TVOC": "TVOC,ppm",
  "windSpeed": "风速,m/s",
  "windDirection": "风向,°",
  "windScale": "风力,级",
  "noise1": "噪声,db",
  "PM10": "PM10,ug/m³",
  "oxygenContent": "氧浓度,%VOL",
  "soilHumi1": "土壤湿度1,%",
  "soilTemp1": "土壤温度1,℃",
  "soilHumi2": "土壤湿度2,%",
  "soilTemp2": "土壤温度2,℃",
  "soilHumi3": "土壤湿度3,%",
  "soilTemp3": "土壤温度3,℃",
  "soilHumi4": "土壤湿度4,%",
  "soilTemp4": "土壤温度4,℃",
  "soilHumi5": "土壤湿度5,%",
  "soilTemp5": "土壤温度5,℃",
  "nitrogen": "氮含量,mg/kg",
  "Phosphorus": "磷含量,mg/kg",
  "Potassium": "钾含量,mg/kg",
  "turbidity": "浊度,NTU",
  "watertemperature": "水温,℃",
  "Moduletemperature": "组件温度,℃",
  "SO2": "二氧化硫,ppm",
  "NO2": "二氧化氮,ppm",
  "CO": "一氧化碳,ppm",
  "O3": "臭氧,ppm",
  "SunHours": "日照时数,h",
  "dewTemp": "露点温度,℃",
  "RainOrSnow": "雨雪状态",
  "soilCond1": "土壤电导率1,uS/cm",
  "soilCond2": "土壤电导率2,uS/cm",
  "soilCond3": "土壤电导率3,uS/cm",
  "soilCond4": "土壤电导率4,uS/cm",
  "soilTemp6": "土壤温度6,℃",
  "soilHumi6": "土壤湿度6,%",
  "soilTemp7": "土壤温度7,℃",
  "soilHumi7": "土壤湿度7,%",
  "soilTemp8": "土壤温度8,℃",
  "soilHumi8": "土壤湿度8,%",
  "soilTemp9": "土壤温度9,℃",
  "soilHumi9": "土壤湿度9,%",
  "soilTemp10": "土壤温度10,℃",
  "soilHumi10": "土壤湿度10,%",
  "soilTemp11": "土壤温度11,℃",
  "soilHumi11": "土壤湿度11,%",
  "soilTemp12": "土壤温度12,℃",
  "soilHumi12": "土壤湿度12,%",
  "waterPH": "水质PH",
  "Waterconductivity": "水质电导率,uS/cm",
  "WaterORP": "水质ORP,mv",
  "ammonia": "氨气,ppm",
  "ambientHum": "湿度,%",
  "ambientTemp": "温度,℃",
  "snowFall1": "雪量1,mm",
  "visibility": "能见度,m",
  "flows": "流速,m/s",
  "dissolvedoxygen": "溶解氧,mg/L",
  "Leafhumidity": "叶面湿度,℃",
  "snowFall2": "雪量2,mm",
  "snowFall3": "雪量3,mm",
  "conductivity": "电导率,uS/cm",
  "Altitude": "海拔高度,m",
  "longitude": "经度,°",
  "latitude": "纬度,°",
  "pressure": "气压,KPa",
  "TSP": "TSP,ug/m³",
  "tnegativeOxygen": "负氧,个/cm³",
  "noise": "噪声,db",
  "tambientHumidity": "湿度,%",
  "negativeOxygen3": "负氧3,个/cm³",
  "negativeOxygen5": "负氧5,个/cm³",
  "negativeOxygen7": "负氧7,个/cm³",
  "negativeOxygen6": "负氧6,个/cm³",
  "negativeOxygen2": "负氧2,个/cm³",
  "tambientkumidity": "环境湿度,%RH",
  "ambientTemperature": "温度,℃",
  "negativeOxygen1": "负氧1,个/cm³",
  "��PM2.5��": "��PM2.5��",
  "PM2.5": "PM2.5,ug/m³",
  " TSP": " TSP,ug/m³",
  "ambientHumidity": "空气湿度,%",
  "negativeOxygen ": "负氧离子,个/cm³",
  "negativeOxygen4": "负氧4,个/cm³",
  "RSSI": "信号强度,dBm",
  " TSP ": " TSP ,ug/m³",
  "ambientkumidity": "环境湿度,%RH",
  "ambientHumidity2": "湿度2,%",
  "noise2": "噪音2,db",
  "pressure2": "气压2,KPa",
  "ambientTemperature2": "温度2,℃",
  "altitude": "海拔高度,m",
  "ambienthumidity": "空气湿度,%",
  "ambientHumidmty": "空气湿度1,%",
  "ambientHumkdity": "空气温度,℃",
  "indoornegativeOxygen": "室内负氧,个/cm³",
  "lightIntensity33": "光照强度33,Lux",
  "Raflow": "流速,m/s",
  "Rwater": "水位,mm",
  "soilPH": "土壤PH",
  "soilTemp13": "土壤温度13,℃",
  "soilTemp15": "土壤温度15,℃",
  "SolarVoltage": "太阳能电压,V",
  "Voltage": "电池电压,V",
  "flow": "流量,m³/s",
  "Leaftemperature": "叶面温度,℃",
  "soilTempG1": "管式温度1,℃",
  "soilTempG2": "管式温度2,℃",
  "soilTempG3": "管式温度3,℃",
  "soilTempG4": "管式温度4,℃",
  "soilTempG5": "管式温度5,℃",
  "soilTempG6": "管式温度6,℃",
  "soilTempG7": "管式温度7,℃",
  "soilTempG8": "管式温度8,℃",
  "soilTempG9": "管式温度9,℃",
  "snowFall": "降雪,mm",
  "Amnitro":"氨氮,mg/L",
  "Ncumulativeflow-H":"负累计流量H,m³",
  "Ncumulativeflow-L":"负累计流量L,m³",
  "Pcumulativeflow-H":"正累计流量H,m³",
  "Pcumulativeflow-L":"正累计流量L,m³",
  "soilCond5":"土壤电导率5,uS/cm",
  "soilCond6":"土壤电导率6,uS/cm",
  "soilCond7":"土壤电导率7,uS/cm",
  "soilCond8":"土壤电导率8,uS/cm",
  "soilCond9":"土壤电导率9,uS/cm",
  "soilCond10":"土壤电导率10,uS/cm",
  "soilCond11":"土壤电导率11,uS/cm",
  "Leafhumidity1":"叶面湿度1,%",
  "Leaftemperature1":"叶面温度1,℃",
  "Leafhumidity2":"叶面湿度2,%",
  "Leaftemperature2":"叶面温度2,℃",
  "waterTem":"水温,℃",
  "Heatflux":"热通量,W/㎡",
  "innegativeOxygen":"室内负氧,个/cm³",
  "outnegativeOxygen":"室外负氧,个/cm³",
  "PH1":"PH1",
  "PH2":"PH2",
  "PH3":"PH3",
  "PH4":"PH4",
  "PH5":"PH5",
  "PH6":"PH6",
  "Dptemperature":"露点温度,℃",
  "Airhumidity":"空气湿度,%",
  "Airtemperature":"空气温度,℃",
  "Stension":"土壤水势,kPa",
  "salt":"盐分,ppm",
  "soilEC":"电导率,uS/cm",
  "NH3":"NH3",
  "CH4":"CH4",
  "VOC":"VOC,ppm",
  "Sradiation":"散辐射,W/m2",
  "Voltage3":"电压3,V",
  "Voltage4":"电压4,V",
  "Roadtemp":"路面温度,℃",
  "Waterfilm":"水膜厚度,mm",
  "Glaciation":"覆冰厚度,mm",
  "Snow":"覆雪厚度,mm",
  "Swiftswim":"湿滑系数",
  "Warning":"泥泞报警,mm",
  "waterT":"水温,℃",
  "current":"流速,m/s",
  "Dradiation":"直辐射,HW/m2",
  "subunitTemp":"背板温度,℃",
  "sunshinetime":"日照时数,h",
  "COD":"COD,mg/L",
  "dissolvedoxygenBH":"溶解氧饱和度,%",
  "NH3Nwastewater":"氨氮废水,mg/L",
  "NO2wastewater":"亚硝酸根,mg/L",
  "nitrogen1":"氮含量1,mg/kg",
  "Phosphorus1":"磷含量1,mg/kg",
  "Potassium1":"钾含量1,mg/kg",
  "nitrogen2":"氮含量2,mg/kg",
  "Phosphorus2":"磷含量2,mg/kg",
  "Potassium2":"钾含量2,mg/kg",
  "nitrogen3":"氮含量3,mg/kg",
  "Phosphorus3":"磷含量3,mg/kg",
  "Potassium3":"钾含量3,mg/kg",
  "nitrogen4":"氮含量4,mg/kg",
  "Phosphorus4":"磷含量4,mg/kg",
  "Potassium4":"钾含量4,mg/kg",
  "snowheight":"超声波雪深,cm",
  "Speed":"航速,m/s",
  "course":"航向,°",
  "ambientTemperature3":"温度3,℃",
  "ambientHumidity3":"湿度3,%",
  "pressure3":"气压3,KPa",
  "ambientTemperature4":"温度4,℃",
  "ambientHumidity4":"湿度4,%",
  "pressure4":"气压4,KPa",
  "ambientTemperature5":"温度5,℃",
  "ambientHumidity5":"湿度5,%",
  "pressure5":"气压5,KPa",
  "BVoltage":"电池电压,V",
  "SVoltage":"太阳能电压,V",
  "H2S":"硫化氢,ppm",
  "waterCO2":"水中二氧化碳,ppm",
  "raininess":"降雨强度,mm",
  "salinity":"水质盐分,ppm",
  "TDS":"水质TDS,ppm",
  "Hradiation":"热电辐射,HW/m²",
  "heatFlux1":"热通量,w/m²",
  "heatFlux2":"热通量,w/m²",
  "hradiation":"太阳总辐射",
  "TotalRadiation1":"总辐射1,HW/m2",
  "TotalRadiation2":"总辐射2,HW/m2",
  "chlorophyll": "叶绿素",
  "BGalgae": "蓝绿藻",
  "waterTem2":"水温2,℃",
  "residualChlorine":"余氯,mg/L",
  "waterlevel":"水位,mm",
  "pow":"电源,V",
  "soilCO2":"土壤CO2,ppm",
  "staticPressure":"静压,kpa",
  "angleX":"倾角-X,°",
  "angleY":"倾角-Y,°",
  "angleZ":"倾角-Z,°",
  "waterPressure":"渗压,kpa",
  "netRadiation":"净辐射,W/m²",
  "soilCond12":"土壤电导率12,uS/cm",
  "KMnO4":"高猛酸盐,mg/L",
  "phosphorus":"总磷,mg/L",
  "conductivity2":"电导率2,uS/cm",
  "waterT2":"水温2,℃",
  "Rchlorine":"余氯,mg/L",
  "NO":"NO,ppm",
  "soilPH1":"土壤PH1",
  "soilPH2":"土壤PH2",
  "soilPH3":"土壤PH3",
  "soilPH4":"土壤PH4",
  "soilPH5":"土壤PH5",
  "soilPH6":"土壤PH6",
  "ODOvalue":"溶解氧,mg/L",
  "ODOfull":"溶解氧饱和,%",
  "Nitrate":"硝酸盐,mg/L",
  "accumulate":"累积流量,m³",
  "nitrogen5":"氮含量5,mg/kg",
  "Phosphorus5":"磷含量5,mg/kg",
  "Potassium5":"钾含量5,mg/kg",
  "nitrogen6":"氮含量6,mg/kg",
  "Phosphorus6":"磷含量6,mg/kg",
  "Potassium6":"钾含量6,mg/kg",
  "He":"氦气,ppm",
  "nitrateNitrogen":"硝氮值,mg/L",
  "heatFlux":"热通量,W/㎡",
  "soilOxygen":"土壤含氧量,%VOL",
  "waterconductivity":"水质电导率,uS/cm",
  "Xangle":"X角度,°",
  "Yangle":"Y角度,°",
  "Zyangle":"Z角度,°",
  "Xdrift":"X方向偏转角,°",
  "Xgression":"X方向位移,mm",
  "Ygression":"Y方向位移,mm",
  "Zgression":"Z方向位移,mm",
  "VI":"烟雾浓度,1/m",
  "Radiation": "光电总辐射,w/m2",
  "RadiationR": "总辐射R,w/m2",
  "RadiationV": "总辐射V,w/m2",
  "waterTSs": "悬浮物,mg/L",
  "TotalPhosphorus": "总磷,mg/L",
  "sunAngle": "太阳高度角,°",
  "sunAzimuth": "太阳方位角,°",
  "Caion": "钙离子,mg/L",
  "awWARR": "短波反射,w/m²",
  "atOLR": "大气长波,w/m²",
  "grdOLR": "地面长波,w/m²",
  "TBI": "全辐射,w/m²",
  "CTBI": "净全辐射,w/m²",
  "CSW": "净短波,w/m²",
  "COLR": "净长波,w/m²",
  "arSW": "短波反照,%",
  "arOLR": "长波反照,%",
  "ambientHumidity1": "湿度1,%",
  "ambientTemperature1": "温度1,℃",
  "NH3Nwater": "氨氮废水,mg/L",
  "snowHeight": "雪深,mm",
  "soilNitrogen": "氮含量,mg/kg",
  "soilPhosphorus": "磷含量,mg/kg",
  "soilPotassium": "钾含量,mg/kg",
  "soilNitrogen1":"氮含量1,mg/kg",
  "soilPhosphorus1":"磷含量1,mg/kg",
  "soilPotassium1":"钾含量1,mg/kg",
  "soilNitrogen2":"氮含量2,mg/kg",
  "soilPhosphorus2":"磷含量2,mg/kg",
  "soilPotassium2":"钾含量2,mg/kg",
  "soilNitrogen3":"氮含量3,mg/kg",
  "soilPhosphorus3":"磷含量3,mg/kg",
  "soilPotassium3":"钾含量3,mg/kg",
  "soilNitrogen4":"氮含量4,mg/kg",
  "soilPhosphorus4":"磷含量4,mg/kg",
  "soilPotassium4":"钾含量4,mg/kg",
  "soilNitrogen5":"氮含量5,mg/kg",
  "soilPhosphorus5":"磷含量5,mg/kg",
  "soilPotassium5":"钾含量5,mg/kg",
  "soilNitrogen6":"氮含量6,mg/kg",
  "soilPhosphorus6":"磷含量6,mg/kg",
  "soilPotassium6":"钾含量6,mg/kg",
  "empty":"空距,M",
  "eor":"误差值,%",
  "dose":"剂量率,uSv/h",
  "dosen":"剂量率,nSv/h",
  "Weather":"天气状况",
  "ponDing":"积水,mm",
  "andFlow":"累计流量,m³",
  "soak":"水浸",
  "CODmn":"化学需氧量",
  "NH3N":"氨氮",
  "TP":"总磷",
  "TN":"总氮",
  "DO":"溶解氧",
  "Turb":"浊度",
  "EC":"电导率",
  "Temp":"水温",
  "amh":"湿度,%RH",
  "pre":"气压,Kpa",
  "noi":"噪声,db",
  "p25":"PM2.5,ug/m³",
  "p10":"PM10,ug/m³",
  "neg":"负氧离子,个/cm³",
  "oxy":"氧浓度,%VOL",
  "wsp":"风速,m/s",
  "wdr":"风向,°",
  "amt":"温度,℃",
  "Rad":"总辐射,w/m2",
  "sut":"日照时数,h",
  "lig":"光照,lux",
  "sH1":"土壤湿度1,%",
  "sT1":"土壤温度1,℃",
  "sH2":"土壤湿度2,%",
  "sT2":"土壤温度2,℃",
  "sH3":"土壤湿度3,%",
  "sT3":"土壤温度3,℃",
  "sH4":"土壤湿度4,%",
  "sT4":"土壤温度4,℃",
  "Radia":"热电辐射,w/m2",
  "sunTme":"日照时数,h",
  "Rhour":"小时累计,wh/m2",
  "Rday":"日累计,wh/m2",
  "Rsum":"总累计,wh/m2",
  "count":"计数率,CPS",
  "flow2":"流量",
  "Rwater2":"水位,mm",
  "solarFlat":"水平辐射,W/m2",
  "solarAngle":"倾角辐射,W/m2",
  "bgalgae":"蓝绿藻,cells/ml",
  "ch2o":"甲醛,ppm",
  "soilhorn":"土壤角度,°",
  "surfaceTemp":"地表温度,℃",
  "litterRH1":"凋落物含水率1,%",
  "litterRH2":"凋落物含水率2,%",
  "litterRH3":"凋落物含水率3,%",
  "surfaceT":"地表温度,℃",
  "surfaceW":"地表湿度,%RH",
  "waterEC":"电导率,μS/cm",
  "CH2O":"甲醛,ppm",
  "Hagne":"镁离子,mg/L",
  "CUMEvapm":"累计蒸发,mm",
  "CUMEvapg":"累计蒸发,g",
  "Evapg":"蒸发时重,g",
  "Evapm":"蒸发时位高,mm",
  "fxd_BatVoltage":"电池电压,V",
  "fxd_fanMode":"风扇状态",
  "fxd_latitude":"纬度,°",
  "fxd_longitude":"经度,°",
  "fxd_PanelVoltage":"光强电压,V",
  "fxd_RSSI":"信号强度,dBm",
  "fxd_uvMode":"诱虫灯状态",
  "Magne":"镁离子,mg/L",
  "chloribe":"氯离子,mg/L",
  "smokeAlarm":"烟雾浓度,ppm",
  "seston":"悬浮物,mg/L",
  "cabletemp":"电缆温度,℃",
  "sS":"表层土壤含水率,%",
  "sW":"内层土壤含水率,%",
  "sD":"土壤含水率,%",
  "sh":"倾斜角度,°",
  "sTe":"地表温度,℃",
  "sHu":"地表湿度,%RH",
  "wS":"风速,m/s",
  "wD":"风向,°",
  "aT":"环境温度,℃",
  "aH":"环境湿度,%",
  "pr":"大气压,KPa",
  "li":"光照,lux",
  "ra":"雨量,mm",
  "lo":"经度,°",
  "la":"纬度,°",
  "height":"高度,m",
  "alt":"海拔,m",
  "lat":"纬度,°",
  "lon":"经度,°",
  "soilCond13": "土壤电导率13,uS/cm",
  "soilHumi13": "土壤湿度13,%",
  "soilCond14": "土壤电导率14,uS/cm",
  "soilHumi14": "土壤湿度14,%",
  "soilTemp14": "土壤温度14,℃",
  "soilCond15": "土壤电导率15,uS/cm",
  "soilHumi15": "土壤湿度15,%",
  "soilCond16": "土壤电导率16,uS/cm",
  "soilHumi16": "土壤湿度16,%",
  "soilTemp16": "土壤温度16,℃",
  "soilCond17": "土壤电导率17,uS/cm",
  "soilHumi17": "土壤湿度17,%",
  "soilTemp17": "土壤温度17,℃",
  "soilCond18": "土壤电导率18,uS/cm",
  "soilHumi18": "土壤湿度18,%",
  "soilTemp18": "土壤温度18,℃",
  "soilCond19": "土壤电导率19,uS/cm",
  "soilHumi19": "土壤湿度19,%",
  "soilTemp19": "土壤温度19,℃",
  "soilCond20": "土壤电导率20,uS/cm",
  "soilHumi20": "土壤湿度20,%",
  "soilTemp20": "土壤温度20,℃",
  "ammoniaIon": "氨氮,mg/L",
  "flowNum": "流量,mL",
  "Chromaticity": "色度",
  "sludge": "污泥,g/L",
  "vSpeedX": "X速度,mm/s",
  "vSpeedY": "Y速度,mm/s",
  "vSpeedZ": "Z速度,mm/s",
  "vdrftX": "X位移,μm",
  "vdrftY": "Y位移,μm",
  "vdrftZ": "Z位移,μm",
  "vPlusX": "X加速度,m/s2",
  "vPlusZ": "Z加速度,m/s2",
  "vibrfrHzX": "X振频,Hz",
  "vibrfrHzY": "Y振频,Hz",
  "vibrfrHzZ": "Z振频,Hz",
  "dewtemp": "露点温度,℃",
  "Sunlight_h": "日照时数,h",
  "ambientHumidity6": "湿度6,%",
  "ambientTemperature6": "温度6,℃",
  "pressure6":"气压6,KPa",
  "windDirection1": "风向1,°",
  "windDirection2": "风向2,°",
  "windDirection3": "风向3,°",
  "windDirection4": "风向4,°",
  "windDirection5": "风向5,°",
  "windDirection6": "风向6,°",
  "windSpeed1": "风速1,m/s",
  "windSpeed2": "风速2,m/s",
  "windSpeed3": "风速3,m/s",
  "windSpeed4": "风速4,m/s",
  "windSpeed5": "风速5,m/s",
  "windSpeed6": "风速6,m/s",
  "Vibr1":"频率CH1",
  "Temp1":"温度CH1",
  "Vibr2":"频率CH2",
  "PAR":"光合有效,W/m2",
  "UVAB":"紫外线,W/m2",
  "Radia1":"热电辐射,w/m2",
  "Rday1":"日累计,j/cm2",
  "PM25":"PM2.5,ug/m³",
  "�y": "�y"
};



// WEBPACK FOOTER //
// ./src/lang/zh.js